import { jsx as _jsx } from "react/jsx-runtime";
import 'slick-carousel';
import Slider from 'react-slick';
import { ListingCard } from './listing-card';
export function ListingsCarousel({ listings }) {
    if (listings.length === 0) {
        return _jsx("div", { className: "listings-carousel", children: _jsx("div", { className: "listings-carousel-empty", children: "No items found" }) });
    }
    return (_jsx("div", { className: "listings-carousel", children: _jsx(Slider, { className: "listings-carousel-slick", arrows: true, dots: false, slidesToShow: 3, slidesToScroll: 3, infinite: false, responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        arrows: false,
                        dots: true,
                    },
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true,
                    },
                },
            ], children: listings.map(listing => (_jsx("div", { className: "listing-card-wrapper", children: _jsx(ListingCard, { listing: listing }) }, listing.id))) }) }));
}
